import { ViewResolver } from '@Components/ViewResolver';
import MobileProfilePage from './mobile';
import DesktopProfileLayout from './desktop';

const ProfilePage: React.FC = () => {
  return (
    <ViewResolver
      desktop={<DesktopProfileLayout />}
      mobile={<MobileProfilePage />}
    />
  );
};

export default ProfilePage;
